import { callFetch, header } from "./utils";

const EndPoint = {
  SendPhoneVerify: (lineId) => `/line/${lineId}/sms-code`,
  VerifyPhone: (lineId) => `/line/${lineId}/sms-verify`,
  SaveCustomerForm: (lineId) => `/line/${lineId}/event-form`,
  GetCustomerForm: (lineId) => `/line/${lineId}/event-form`,
  GetActivityCustomerForm: (lineId) => `/line/${lineId}/form`,
  GetPrevActivityCustomerForm: (lineId) => `/line/${lineId}/prev-form`,
};

export function sendPhoneVerify(lineId, phoneNumber) {
  const uri = EndPoint.SendPhoneVerify(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({
      phoneNumber,
      options: {
        length: 4,
        hasCharacter: false,
        verifyCodeMessage: "您的驗證碼為{{code}}，請於15分鐘內驗證。",
      },
    }),
  };

  return callFetch(uri, settings);
}

export function verifyPhone(lineId, phoneNumber, verifyCode) {
  const uri = EndPoint.VerifyPhone(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify({ phoneNumber, verifyCode }),
  };

  return callFetch(uri, settings);
}

export function saveCustomerForm(lineId, body) {
  const uri = EndPoint.SaveCustomerForm(lineId);
  let settings = {
    method: "POST",
    headers: header,
    body: JSON.stringify(body),
  };

  return callFetch(uri, settings);
}

export function getCustomerForm(lineId) {
  const uri = EndPoint.GetCustomerForm(lineId);
  let settings = {
    method: "GET",
    headers: header,
  };

  return callFetch(uri, settings);
}

export function getActivityCustomerForm(lineId) {
  const uri = EndPoint.GetActivityCustomerForm(lineId);
  let settings = {
    method: "GET",
    headers: header,
  };

  return callFetch(uri, settings);
}

export function getPrevActivityCustomerForm(lineId) {
  const uri = EndPoint.GetPrevActivityCustomerForm(lineId);
  let settings = {
    method: "GET",
    headers: header,
  };

  return callFetch(uri, settings);
}
